module.exports = __webpack_public_path__ + "img/colaboracionuniversidades.6b68ab5f.png";